import { Table, Input, Select, Sheet, Button, Chip } from "@mui/joy";
import { Mileage, ShiftType, User } from "../../types";
import { hour_types } from "../../utils/helpers";
import LaunchIcon from '@mui/icons-material/Launch';
import { FC, useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MilageEntries from "../mileage/MilageEntries";
import toast from "react-hot-toast";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import MonthBilledIn from "../mileage/MonthBilledIn";

interface PendingMileageProps {
    entries: Mileage[]
    refresh: () => Promise<void>
    month: string
}
const PendingMileages: FC<PendingMileageProps> = function ({ entries, refresh, month }) {

    const [approveOpen, setApproveOpen] = useState(false)
    function onApproveChange() {
        setApproveOpen(prev => !prev);
    }
    console.log('Mileage comp');
    const [isOpen, setIsOpen] = useState(false)
    const [id, setId] = useState<string>()

    const [user, setUser] = useState('')
    function onOpenChange() {
        setIsOpen(prev => !prev)
        if (isOpen) {
            refresh()
        }
    }

    const [currentSelected, setCurrentSelected] = useState<string | null>(null)
    const approve = useCallback(async function (approve: boolean, month: string) {
        try {

            const response = await fetch(process.env.REACT_APP_server + "/mileage/" + currentSelected + "/approve", {
                method: 'PATCH',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify({ month })
            })

            const data = await response.json()

            if (data.error || !data.success) {
                toast.error(data.error || "Something went wrong")
                return
            }

            toast.success("Approved Successfully!")
            refresh()
        } catch (error) {
            console.log(error)
        }
    }, [currentSelected])




    return (
        <Sheet sx={{ height: '60dvh', overflow: 'auto' }}>
            <MilageEntries isOpen={isOpen} onOpenChange={onOpenChange} id={id!} month={month} user={user} />
            <MonthBilledIn isOpen={approveOpen} onOpenChange={onApproveChange} approve={approve} />
            <Table aria-label="table 'outlined's" variant={'soft'} sx={{
                overflowX: 'scroll',
                width: '100%',
                // paddingLeft: 1
                mt: 1
            }} stickyHeader={true}>
                <thead >
                    <tr style={{ backgroundColor: 'black', color: 'white' }}>
                        <th style={{ backgroundColor: 'black', color: 'white', width: 200 }}>User</th>
                        <th style={{ backgroundColor: 'black', color: 'white', width: 200 }}>Member</th>
                        <th style={{ backgroundColor: 'black', color: 'white', width: 200 }}>Status</th>
                        <th style={{ backgroundColor: 'black', color: 'white', width: 200 }}>Total Mileage</th>
                        <th style={{ backgroundColor: 'black', color: 'white', width: 200 }}>Total Expense</th>
                        <th style={{ backgroundColor: 'black', color: 'white', width: 200 }}>Action</th>
                        <th style={{ backgroundColor: 'black', color: 'white', width: 200 }}>Time created</th>
                    </tr>

                </thead>

                <tbody >

                    {entries?.map((entry) => {
                        return (
                            <tr onDoubleClick={() => {
                                setId(entry._id)
                                setUser(entry.username)
                                onOpenChange()
                            }}>
                                <td>{entry.username}</td>
                                <td>{entry.member}</td>
                                <td><Button color="success" onClick={
                                    () => {
                                        setCurrentSelected(entry._id)
                                        setApproveOpen(true)
                                    }
                                }>Approve</Button></td>
                                <td>{entry.totalKm}</td>
                                <td>{entry.totalBridge + entry.totalParking}</td>
                                <td style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 16
                                }}>
                                    <div onClick={() => {
                                        setId(entry._id)
                                        setIsOpen(true)
                                        setUser(entry.username)

                                    }}>
                                        <OpenInNewIcon style={{
                                            cursor: 'pointer',
                                            // fontSize: 
                                        }} />
                                    </div>
                                    <Button onClick={() => [
                                        fetch(`${process.env.REACT_APP_server}/mileage/${entry._id}/download`, {
                                            method: "GET",
                                            headers: {
                                                'Content-type': 'application/json',
                                                'Authorization': 'Bearer ' + localStorage.getItem('token')
                                            }
                                        }).then((data) => data.blob()).then((blob) => {
                                            const url = window.URL.createObjectURL(blob);
                                            const a = document.createElement('a');
                                            a.href = url;
                                            a.download = entry.username + "-" + entry.member + "-(" + month + ")"
                                            document.body.appendChild(a);
                                            a.click();
                                            document.body.removeChild(a);
                                            window.URL.revokeObjectURL(url);
                                        }).catch((err) => {
                                            console.log(err);
                                        })
                                    ]}>Download</Button></td>
                                <td>{entry.timestamp && new Date(entry.timestamp).toLocaleString()}</td>
                                {/* {entry._id ? <td style={{ display: 'flex', alignItems: 'center' }}>
                                    <Link to={`/timesheets/${entry._id}`} style={{
                                        color: 'black',
                                        marginRight: 10
                                    }}><LaunchIcon /></Link>
                                    <Button variant="outlined" size="sm" color="success" onClick={() => {
                                        fetch(`${process.env.REACT_APP_server}/timesheets/file/weekly/${entry._id}`, {
                                            method: "GET",
                                            headers: {
                                                'Content-type': 'application/json',
                                                'Authorization': 'Bearer ' + localStorage.getItem('token')
                                            }
                                        }).then((data) => data.blob()).then((blob) => {
                                            const url = window.URL.createObjectURL(blob);
                                            const a = document.createElement('a');
                                            a.href = url;
                                            a.download = entry?.user_id?.first_name + " " + entry?.user_id?.last_name
                                            document.body.appendChild(a);
                                            a.click();
                                            document.body.removeChild(a);
                                            window.URL.revokeObjectURL(url);
                                        }).catch((err) => {
                                            console.log(err);
                                        })
                                    }}>Download CSV</Button>
                                </td> : "N/A"
                                } */}
                            </tr>
                        )
                    })}



                </tbody>

            </Table>
        </Sheet>
    )
}


export default PendingMileages;
